import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f6747f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row settings-content-inner settings-content-inner-system" }
const _hoisted_2 = { class: "column settings-content-inner-column" }
const _hoisted_3 = {
  class: "row settings-content-box",
  style: {"margin-top":"20px"}
}
const _hoisted_4 = { class: "settings-general-inputs-grid" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "setting-content-box-subtitle row" }
const _hoisted_8 = {
  id: "settings-input-agent-communication-port",
  class: "setting-content-box-input"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Only one port change can be saved at a time. Click Save All or Discard All to edit this port", -1))
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "setting-content-box-subtitle row" }
const _hoisted_12 = {
  id: "settings-input-dashboard-port",
  class: "setting-content-box-input"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Only one port change can be saved at a time. Click Save All or Discard All to edit this port", -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "setting-content-box-subtitle row" }
const _hoisted_17 = {
  id: "settings-input-coordinator-server-port",
  class: "setting-content-box-input"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Only one port change can be saved at a time. Click Save All or Discard All to edit this port", -1))
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "setting-content-box-subtitle row" }
const _hoisted_21 = {
  id: "settings-input-license-port",
  class: "setting-content-box-input"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Only one port change can be saved at a time. Click Save All or Discard All to edit this port", -1))
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "setting-content-box-subtitle row" }
const _hoisted_26 = { class: "setting-content-box-input input-width" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = {
  class: "col",
  "data-testid": "settings-general-prometheus"
}
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "text-[11px] mb-3" }
const _hoisted_31 = { class: "font-gordita-regular text-[13px] prometheus-title" }
const _hoisted_32 = {
  key: 0,
  class: "col checkbox-data-margin"
}
const _hoisted_33 = { class: "setting-content-box-subtitle row" }
const _hoisted_34 = { class: "setting-content-box-subtitle row description-text" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_36 = {
  id: "settings-input-prometheus-port",
  class: "setting-content-box-input"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Only one port change can be saved at a time. Click Save All or Discard All to edit this port", -1))
const _hoisted_38 = { class: "col" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = {
  key: 0,
  class: "row"
}
const _hoisted_41 = { class: "col checkbox-data-margin" }
const _hoisted_42 = { class: "setting-content-box-subtitle row" }
const _hoisted_43 = {
  id: "settings-input-secured-port",
  class: "setting-content-box-input"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Only one port change can be saved at a time. Click Save All or Discard All to edit this port", -1))
const _hoisted_45 = { class: "column settings-content-inner-column" }
const _hoisted_46 = { class: "row settings-content-box" }
const _hoisted_47 = { class: "setting-content-box-input" }
const _hoisted_48 = { class: "setting-content-box-input-checkbox" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "setting-content-box-subtitle row telemetry-width" }
const _hoisted_51 = { class: "row settings-content-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TooltipBtn = _resolveComponent("TooltipBtn")!
  const _component_QTooltip = _resolveComponent("QTooltip")!
  const _component_SettingsPortInput = _resolveComponent("SettingsPortInput")!
  const _component_IncrediInputNumWithMenu = _resolveComponent("IncrediInputNumWithMenu")!
  const _component_IncrediCheckBox = _resolveComponent("IncrediCheckBox")!
  const _component_IncrediTooltip = _resolveComponent("IncrediTooltip")!
  const _component_incrediLink = _resolveComponent("incrediLink")!
  const _component_AgentCertificateValidation = _resolveComponent("AgentCertificateValidation")!
  const _component_SettingsItemBox = _resolveComponent("SettingsItemBox")!
  const _component_settings_active_directory = _resolveComponent("settings-active-directory")!
  const _component_SettingsBackupDropdownBox = _resolveComponent("SettingsBackupDropdownBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SettingsItemBox, {
        header: _ctx.$t('settings.general.network.title'),
        subtitle: 'Only one port change can be saved at a time'
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.general.network.port.text')), 1),
                    _createVNode(_component_TooltipBtn, {
                      "data-testid": _ctx.elementsIds.settings.form.windows.general.agentCommunicationPortTooltipIcon,
                      "tooltip-width": 207,
                      "btn-icon": "icon-question-circle",
                      style: {"margin-left":"7px"},
                      "tooltip-title": _ctx.$t('settings.general.network.port.tooltip')
                    }, null, 8, ["data-testid", "tooltip-title"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.areMorePortsAreDirty('settings.windows.coordinator.agentCommunicationPort'))
                      ? (_openBlock(), _createBlock(_component_QTooltip, {
                          key: 0,
                          class: "tooltip-background",
                          delay: 300
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_SettingsPortInput, {
                      "data-testid": _ctx.elementsIds.settings.form.windows.general.agentCommunicationPort,
                      "input-for": "agent-communication-port",
                      disable: 
                      !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general ||
                      _ctx.areMorePortsAreDirty('settings.windows.coordinator.agentCommunicationPort') ||
                      _ctx.license?.windows?.type === _ctx.LICENSE_TYPES.Marketplace
                    ,
                      mask: "#####",
                      error: _ctx.validPorts?.['settings.windows.coordinator.agentCommunicationPort'].isValid === false,
                      "error-message": _ctx.getPortRangeValidationErrorMessage(_ctx.settingsObject?.settings?.windows?.coordinator?.agentCommunicationPort || 0),
                      rules: [(value) => _ctx.validPorts?.['settings.windows.coordinator.agentCommunicationPort'].isValid !== false || _ctx.getPortRangeValidationErrorMessage(value)],
                      loading: _ctx.validPorts?.['settings.windows.coordinator.agentCommunicationPort'].isFetching,
                      "is-port-valid": (_ctx.validPorts?.['settings.windows.coordinator.agentCommunicationPort'].isValid as any),
                      "field-name": _ctx.SETTINGS_OBJ.Port,
                      value: _ctx.settingsObject?.settings?.windows?.coordinator?.agentCommunicationPort,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = 
                      (val) => {
                        _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.coordinator.agentCommunicationPort, val);
                      }
                    )
                    }, null, 8, ["data-testid", "disable", "error", "error-message", "rules", "loading", "is-port-valid", "field-name", "value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.general.network.coordPort.text')), 1),
                    _createVNode(_component_TooltipBtn, {
                      "data-testid": _ctx.elementsIds.settings.form.windows.general.coordinatorUIPortTooltipIcon,
                      "tooltip-width": 207,
                      "btn-icon": "icon-question-circle",
                      style: {"margin-left":"7px"},
                      "tooltip-title": _ctx.$t('settings.general.network.coordPort.tooltip')
                    }, null, 8, ["data-testid", "tooltip-title"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.areMorePortsAreDirty('settings.common.ibManager.ibManagerPort'))
                      ? (_openBlock(), _createBlock(_component_QTooltip, {
                          key: 0,
                          class: "tooltip-background",
                          delay: 300
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_SettingsPortInput, {
                      "input-for": "ib-manager-port",
                      "data-testid": _ctx.elementsIds.settings.form.windows.general.coordinatorUIPort,
                      mask: "#####",
                      disable: 
                      !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general ||
                      _ctx.areMorePortsAreDirty('settings.common.ibManager.ibManagerPort') ||
                      _ctx.license?.windows?.type === _ctx.LICENSE_TYPES.Marketplace
                    ,
                      loading: _ctx.validPorts?.['settings.common.ibManager.ibManagerPort'].isFetching,
                      error: _ctx.validPorts?.['settings.common.ibManager.ibManagerPort'].isValid === false,
                      "error-message": _ctx.getPortRangeValidationErrorMessage(_ctx.settingsObject?.settings?.common?.ibManager?.ibManagerPort || 0),
                      rules: [(value) => _ctx.validPorts?.['settings.common.ibManager.ibManagerPort'].isValid !== false || _ctx.getPortRangeValidationErrorMessage(value)],
                      value: _ctx.settingsObject?.settings?.common?.ibManager?.ibManagerPort,
                      "field-name": _ctx.SETTINGS_OBJ.DashboardPort,
                      "is-port-valid": (_ctx.validPorts?.['settings.common.ibManager.ibManagerPort'].isValid as any),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = 
                      (val) => {
                        _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.common.ibManager.ibManagerPort, val);
                      }
                    )
                    }, null, 8, ["data-testid", "disable", "loading", "error", "error-message", "rules", "value", "field-name", "is-port-valid"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.general.network.coordServerPort.text')), 1),
                    _createVNode(_component_TooltipBtn, {
                      "data-testid": _ctx.elementsIds.settings.form.windows.general.coordinatorServerPortTooltipIcon,
                      "tooltip-width": 207,
                      "btn-icon": "icon-question-circle",
                      style: {"margin-left":"7px"},
                      "tooltip-title": _ctx.$t('settings.general.network.coordServerPort.tooltip')
                    }, null, 8, ["data-testid", "tooltip-title"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    (_ctx.areMorePortsAreDirty('settings.windows.coordinator.restServicePort'))
                      ? (_openBlock(), _createBlock(_component_QTooltip, {
                          key: 0,
                          class: "tooltip-background",
                          delay: 300
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_SettingsPortInput, {
                      "data-testid": _ctx.elementsIds.settings.form.windows.general.coordinatorServerPort,
                      "input-for": "rest-service-port",
                      disable: 
                      !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general ||
                      _ctx.areMorePortsAreDirty('settings.windows.coordinator.restServicePort') ||
                      _ctx.license?.windows?.type === _ctx.LICENSE_TYPES.Marketplace
                    ,
                      mask: "#####",
                      loading: _ctx.validPorts?.['settings.windows.coordinator.restServicePort'].isFetching,
                      error: _ctx.validPorts?.['settings.windows.coordinator.restServicePort'].isValid === false,
                      "error-message": _ctx.getPortRangeValidationErrorMessage(_ctx.settingsObject?.settings?.windows?.coordinator?.restServicePort || 0),
                      rules: [(value) => _ctx.validPorts?.['settings.windows.coordinator.restServicePort'].isValid !== false || _ctx.getPortRangeValidationErrorMessage(value)],
                      "field-name": _ctx.SETTINGS_OBJ.CoordAPIPort,
                      "is-port-valid": (_ctx.validPorts?.['settings.windows.coordinator.restServicePort'].isValid as any),
                      value: _ctx.settingsObject?.settings?.windows?.coordinator?.restServicePort,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = 
                      (val) => {
                        _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.coordinator.restServicePort, val);
                      }
                    )
                    }, null, 8, ["data-testid", "disable", "loading", "error", "error-message", "rules", "field-name", "is-port-valid", "value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.general.network.licensePort.text')), 1),
                    _createVNode(_component_TooltipBtn, {
                      "data-testid": _ctx.elementsIds.settings.form.windows.general.licensePortTooltipIcon,
                      "tooltip-width": 207,
                      "btn-icon": "icon-question-circle",
                      style: {"margin-left":"7px"},
                      "tooltip-title": _ctx.$t('settings.general.network.licensePort.tooltip')
                    }, null, 8, ["data-testid", "tooltip-title"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    (_ctx.areMorePortsAreDirty('settings.windows.license.licenseServerPort'))
                      ? (_openBlock(), _createBlock(_component_QTooltip, {
                          key: 0,
                          class: "tooltip-background",
                          delay: 300
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_SettingsPortInput, {
                      "input-for": "license-server-port",
                      "data-testid": _ctx.elementsIds.settings.form.windows.general.licensePort,
                      mask: "#####",
                      disable: 
                      !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general ||
                      _ctx.areMorePortsAreDirty('settings.windows.license.licenseServerPort') ||
                      _ctx.license?.windows?.type === _ctx.LICENSE_TYPES.Marketplace
                    ,
                      loading: _ctx.validPorts?.['settings.windows.license.licenseServerPort'].isFetching,
                      error: _ctx.validPorts?.['settings.windows.license.licenseServerPort'].isValid === false,
                      "error-message": _ctx.getPortRangeValidationErrorMessage(_ctx.settingsObject?.settings?.windows?.license?.licenseServerPort || 0),
                      rules: [(value) => _ctx.validPorts?.['settings.windows.license.licenseServerPort'].isValid !== false || _ctx.getPortRangeValidationErrorMessage(value)],
                      value: _ctx.settingsObject?.settings?.windows?.license?.licenseServerPort,
                      "field-name": _ctx.SETTINGS_OBJ.LicensePort,
                      "is-port-valid": (_ctx.validPorts?.['settings.windows.license.licenseServerPort'].isValid as any),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = 
                      (val) => {
                        _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.license.licenseServerPort, val);
                      }
                    )
                    }, null, 8, ["data-testid", "disable", "loading", "error", "error-message", "rules", "value", "field-name", "is-port-valid"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.general.network.reportInterval.text')), 1),
                    _createVNode(_component_TooltipBtn, {
                      "data-testid": _ctx.elementsIds.settings.form.windows.general.reportIntervalTooltipIcon,
                      "tooltip-width": 207,
                      "btn-icon": "icon-question-circle",
                      style: {"margin-left":"7px"},
                      "tooltip-title": _ctx.$t('settings.general.network.reportInterval.tooltip')
                    }, null, 8, ["data-testid", "tooltip-title"])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_IncrediInputNumWithMenu, {
                      disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general,
                      "default-option": _ctx.inputsWithMenuSelectedOption['report-interval-component'],
                      value: _ctx.settingsObject?.settings?.windows?.agent?.reportInterval,
                      filter: 'timeForm',
                      class: "heartbeat-sizing row hover-shadow incredi-text-transform-lowercase",
                      "menu-options": ['SEC'],
                      placeholder: "0",
                      "input-width": "67",
                      "menu-min-width": "64",
                      "id-name": "report-interval-component",
                      mask: "#######",
                      "min-value": 1,
                      "max-value": 59,
                      onOptionSelected: _ctx.handleInputWithMenuSelection,
                      onInputChange: _cache[4] || (_cache[4] = 
                      (newVal, selectedOption) => {
                        _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.agent.reportInterval, _ctx.util.convertTimeToSEC(newVal, selectedOption));
                      }
                    )
                    }, null, 8, ["disable", "default-option", "value", "onOptionSelected"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_IncrediTooltip, {
                      "model-value": _ctx.prometheusTooltip,
                      "offset-y": 12,
                      delay: 200,
                      direction: "top-middle",
                      hover: "",
                      "onUpdate:modelValue": _ctx.toggleTooltip
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('settings.general.network.prometheusPort.tooltip')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_IncrediCheckBox, {
                          disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general || !_ctx.hasApiAccessFeature,
                          class: "checkbox-padding",
                          "label-for": "checkbox-check-for-updates",
                          "data-testid": "settings-general-enable-prometheus-checkbox",
                          value: !!_ctx.settingsObject?.settings?.windows?.system?.prometheusEnabled,
                          onInput: _cache[5] || (_cache[5] = 
                    (e) => {
                      _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.system.prometheusEnabled, e);
                    }
                    )
                        }, null, 8, ["disable", "value"])
                      ]),
                      _: 1
                    }, 8, ["model-value", "onUpdate:modelValue"]),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('settings.general.network.prometheusPort.enableTitle')), 1)
                  ]),
                  (_ctx.settingsObject?.settings?.windows?.system?.prometheusEnabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.general.network.prometheusPort.text')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t('settings.general.network.prometheusPort.descriptionA')) + " ", 1),
                            _createVNode(_component_incrediLink, {
                              class: "port-link",
                              text: _ctx.$t('settings.general.network.prometheusPort.linkText'),
                              url: _ctx.$t('settings.general.network.prometheusPort.url')
                            }, null, 8, ["text", "url"]),
                            _hoisted_35,
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.general.network.prometheusPort.descriptionB')), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          (_ctx.areMorePortsAreDirty('settings.windows.system.prometheusPort'))
                            ? (_openBlock(), _createBlock(_component_QTooltip, {
                                key: 0,
                                class: "tooltip-background",
                                delay: 300
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_37
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_SettingsPortInput, {
                            "input-for": "prometheus-port",
                            "data-testid": _ctx.elementsIds.settings.form.windows.general.prometheusPort,
                            mask: "#####",
                            disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general || _ctx.areMorePortsAreDirty('settings.windows.system.prometheusPort'),
                            loading: _ctx.validPorts?.['settings.windows.system.prometheusPort'].isFetching,
                            "error-message": _ctx.getPortRangeValidationErrorMessage(_ctx.settingsObject?.settings?.windows?.system?.prometheusPort || 0),
                            error: _ctx.validPorts?.['settings.windows.system.prometheusPort'].isValid === false,
                            value: _ctx.settingsObject?.settings?.windows?.system?.prometheusPort,
                            "field-name": _ctx.SETTINGS_OBJ.PrometheusPort,
                            "is-port-valid": (_ctx.validPorts?.['settings.windows.system.prometheusPort'].isValid as any),
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = 
                        (val) => {
                          _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.system.prometheusPort, val);
                        }
                      )
                          }, null, 8, ["data-testid", "disable", "loading", "error-message", "error", "value", "field-name", "is-port-valid"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_IncrediCheckBox, {
                      class: "checkbox-padding",
                      disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general,
                      "label-for": "checkbox-check-for-updates",
                      label: _ctx.$t('settings.general.network.agentsUseSecureConnections.text'),
                      value: !!_ctx.settingsObject?.settings?.windows?.coordinator?.agentsUseSecureCommunication,
                      onInput: _cache[7] || (_cache[7] = 
                    (e) => {
                      _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.coordinator.agentsUseSecureCommunication, e);
                    }
                  )
                    }, null, 8, ["disable", "label", "value"])
                  ]),
                  (_ctx.settingsObject?.settings?.windows?.coordinator?.agentsUseSecureCommunication)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.general.network.securedPort.text')), 1),
                            _createVNode(_component_TooltipBtn, {
                              "data-testid": _ctx.elementsIds.settings.form.windows.general.securedPortTooltipIcon,
                              "tooltip-width": 207,
                              "btn-icon": "icon-question-circle",
                              style: {"margin-left":"7px"},
                              "tooltip-title": _ctx.$t('settings.general.network.securedPort.tooltip')
                            }, null, 8, ["data-testid", "tooltip-title"])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            (_ctx.areMorePortsAreDirty('settings.windows.license.licenseServerPort'))
                              ? (_openBlock(), _createBlock(_component_QTooltip, {
                                  key: 0,
                                  class: "tooltip-background",
                                  delay: 300
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_44
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_SettingsPortInput, {
                              "input-for": "agent-communication-ssl-port",
                              "data-testid": _ctx.elementsIds.settings.form.windows.general.securedPort,
                              mask: "#####",
                              disable: 
                          !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general ||
                          _ctx.areMorePortsAreDirty('settings.windows.coordinator.agentCommunicationSSLPort') ||
                          _ctx.license?.windows?.type === _ctx.LICENSE_TYPES.Marketplace
                        ,
                              loading: _ctx.validPorts?.['settings.windows.coordinator.agentCommunicationSSLPort'].isFetching,
                              "error-message": _ctx.getPortRangeValidationErrorMessage(_ctx.settingsObject?.settings?.windows?.coordinator?.agentCommunicationSSLPort || 0),
                              error: _ctx.validPorts?.['settings.windows.coordinator.agentCommunicationSSLPort'].isValid === false,
                              value: _ctx.settingsObject?.settings?.windows?.coordinator?.agentCommunicationSSLPort,
                              "field-name": _ctx.SETTINGS_OBJ.SSLPort,
                              "is-port-valid": (_ctx.validPorts?.['settings.windows.coordinator.agentCommunicationSSLPort'].isValid as any),
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = 
                          (val) => {
                            _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.coordinator.agentCommunicationSSLPort, val);
                          }
                        )
                            }, null, 8, ["data-testid", "disable", "loading", "error-message", "error", "value", "field-name", "is-port-valid"])
                          ]),
                          _createVNode(_component_AgentCertificateValidation, {
                            disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general,
                            "model-value": _ctx.settingsObject
                          }, null, 8, ["disable", "model-value"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createVNode(_component_SettingsItemBox, {
        header: _ctx.$t('settings.general.system.title')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_component_IncrediCheckBox, {
                  class: "checkbox-padding",
                  disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general,
                  "label-for": "checkbox-allow-system-standby",
                  label: _ctx.$t('settings.general.system.allowSystemStandby.text'),
                  value: !!_ctx.settingsObject?.settings?.windows?.system?.allowSystemStandby,
                  onInput: _cache[9] || (_cache[9] = 
                  (e) => {
                    _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.system.allowSystemStandby, e);
                  }
                )
                }, null, 8, ["disable", "label", "value"]),
                _createVNode(_component_IncrediCheckBox, {
                  class: "checkbox-padding",
                  disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general,
                  "label-for": "checkbox-ignore-firewall",
                  label: _ctx.$t('settings.general.system.ignoreFirewall.text'),
                  value: !!_ctx.settingsObject?.settings?.windows?.system?.ignoreFirewall,
                  onInput: _cache[10] || (_cache[10] = 
                  (e) => {
                    _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.system.ignoreFirewall, e);
                  }
                )
                }, null, 8, ["disable", "label", "value"]),
                _createVNode(_component_IncrediCheckBox, {
                  class: "checkbox-padding",
                  disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general || _ctx.shouldDisableTelemetry,
                  "label-for": "checkbox-telemetry-enabled",
                  label: _ctx.$t('settings.general.system.helpUsImprove.text'),
                  value: _ctx.shouldDisableTelemetry ? true : !!_ctx.settingsObject?.settings?.windows?.system?.telemetryEnabled,
                  onInput: _cache[11] || (_cache[11] = 
                  (e) => {
                    _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.system.telemetryEnabled, _ctx.shouldDisableTelemetry ? true : e);
                  }
                )
                }, null, 8, ["disable", "label", "value"]),
                (_ctx.showAllowCustomDistributionProfiles)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createVNode(_component_IncrediCheckBox, {
                        class: "checkbox-padding",
                        disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general,
                        "label-for": "checkbox-telemetry-enabled",
                        label: _ctx.$t('settings.general.system.allowCustomDistributionProfiles.text'),
                        value: !!_ctx.settingsObject?.settings?.windows?.system?.allowCustomDistributionProfiles,
                        onInput: _cache[12] || (_cache[12] = 
                    (e) => {
                    _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.system.allowCustomDistributionProfiles, e);
                  }
                )
                      }, null, 8, ["disable", "label", "value"]),
                      _createVNode(_component_TooltipBtn, {
                        "tooltip-width": 280,
                        "btn-icon": "icon-question-circle",
                        style: {"margin-left":"8px","margin-bottom":"8px"},
                        "tooltip-title": _ctx.$t('settings.general.system.allowCustomDistributionProfiles.tooltip')
                      }, null, 8, ["tooltip-title"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_SettingsItemBox, {
        header: _ctx.$t('settings.general.coreLimit.title')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.general.coreLimit.forEachBuild.text')), 1)
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createVNode(_component_SettingsPortInput, {
              "data-testid": _ctx.elementsIds.settings.form.windows.general.coreLimit,
              disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general,
              "input-for": "agent-max-workers",
              value: _ctx.settingsObject?.settings?.windows?.agent?.maxWorkers,
              debounce: "100",
              mask: "#####",
              "field-name": _ctx.SETTINGS_OBJ.MaxWorkers,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = 
              (val) => {
                _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.windows.agent.maxWorkers, val);
              }
            )
            }, null, 8, ["data-testid", "disable", "value", "field-name"])
          ])
        ]),
        _: 1
      }, 8, ["header"]),
      (!!_ctx.featureFlags?.auth && _ctx.showExternalManagement)
        ? (_openBlock(), _createBlock(_component_settings_active_directory, {
            key: 0,
            enabled: !!_ctx.settingsObject?.settings?.common?.auth?.enabled,
            auth: _ctx.settingsObject?.settings?.common?.auth
          }, null, 8, ["enabled", "auth"]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_SettingsBackupDropdownBox, {
        disable: !_ctx.userRolePermissions.authorize?.value?.settings.enabled.general,
        "model-value": _ctx.settingsObject,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = 
        (val) => {
            _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.common.backup.otherCoordinatorHost, val.OtherCoordHost);
            _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.common.backup.otherCoordinatorName, val.OtherCoordDisplay);
            _ctx.settingsDirty?.setInputsDirty(_ctx.QUERY_RESULT_PATH.settings.common.backup.otherCoordinatorPort, val.OtherCoordPort);
          }
        )
      }, null, 8, ["disable", "model-value"]), [
        [_vShow, (_ctx.isFeatureOn as any)('BACKUP')]
      ])
    ])
  ]))
}